import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

function cleanCell(value) {
  if (value === null || value === undefined) return "";

  // Convert non-string values to string
  if (typeof value !== "string") {
    value = String(value);
  }

  // Remove control characters and invalid unicode for Excel
  value = value.replace(/[\x00-\x08\x0B-\x0C\x0E-\x1F\uFFFE\uFFFF]/g, "");

  // Remove special Word characters (like smart quotes, non-breaking spaces, etc.)
  value = value
    .replace(/[\u2018\u2019\u201A\u201B\u2039\u203A]/g, "'") // single quotes
    .replace(/[\u201C\u201D\u201E\u201F\u00AB\u00BB]/g, '"') // double quotes
    .replace(/\u00A0/g, " "); // non-breaking space

  // Excel cell limit: 32,767 characters
 /*  if (value.length > 32767) {
    value = value.substring(0, 32767);
  } */

  return value;
}

export const exportToExcel = (
  rows,
  columns,
  filename,
  exclude_action_column = true
) => {
  const formattedRows = rows.map((row) => {
    let formattedRow = {};
    let i = 0;
    const column_count = exclude_action_column
      ? columns.length
      : columns.length + 1;

    columns.forEach((column) => {
      i++;
      if (i < column_count) {
        formattedRow[column.headerName] = cleanCell(row[column.field]);
      }
    });

    return formattedRow;
  });

  const worksheet = XLSX.utils.json_to_sheet(formattedRows);

  // Définir la largeur des colonnes
  worksheet["!cols"] = columns.map((column) => ({ wpx: column.width }));

  // Appliquer un style aux en-têtes
  const range = XLSX.utils.decode_range(worksheet["!ref"]);
  for (let C = range.s.c; C <= range.e.c; ++C) {
    const cell_address = XLSX.utils.encode_cell({ c: C, r: 0 });
    if (!worksheet[cell_address]) continue;
    worksheet[cell_address].s = {
      font: {
        bold: true,
        color: { rgb: "FFFFFF" },
      },
      fill: {
        fgColor: { rgb: "4F81BD" },
      },
    };
  }

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Data");

  const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });

  const data = new Blob([excelBuffer], { type: "application/octet-stream" });

  saveAs(
    data,
    (filename && filename !== "" ? filename : "Exported_data") + ".xlsx"
  );
};


